const INCREMENT_PAGE_COUNT = 'INCREMENT_PAGE_COUNT';
// const MULTIPLE_PAGES_THRESHOLD = 2;

export function incrementPageCount() {
  return { type: INCREMENT_PAGE_COUNT };
}

export function pageCountReducer(state = { count: 0, multiplePagesVisited: false, cycle: 0 }, action = {}) {
  switch (action.type) {
    case INCREMENT_PAGE_COUNT: {
      const newCount = state.count + 1;
      return {
        ...state,
        count: newCount,
        // multiplePagesVisited: newCount >= MULTIPLE_PAGES_THRESHOLD,
        // cycle: Math.floor(newCount / MULTIPLE_PAGES_THRESHOLD),
      };
    }
    default:
      return state;
  }
}